module.exports = __webpack_public_path__ + "static/media/sign-in-bg.4f18c4f0.png";